import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const PDF_CLOSE_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const PDF_DATE_NOT_APPLICABLE = 'N/A';

type PdfCloseDateTicket = {
  ticketPendingValidationDateTime?: string | Date | null;
  ticketClosedDateTime?: string | Date | null;
};

const hasDateValue = (value?: string | Date | null): value is string | Date => {
  if (value == null) return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  return dayjs.utc(value).isValid();
};

export const formatPdfDateTime = (value?: string | Date | null): string => {
  if (!hasDateValue(value)) return PDF_DATE_NOT_APPLICABLE;

  return dayjs.utc(value).local().format(PDF_CLOSE_DATETIME_FORMAT);
};

export const getPdfClosedDateTime = (
  ticket?: PdfCloseDateTicket | null
): string => formatPdfDateTime(ticket?.ticketClosedDateTime);

export const getPdfPendingValidationDateTime = (
  ticket?: PdfCloseDateTicket | null
): string => formatPdfDateTime(ticket?.ticketPendingValidationDateTime);
